import React from 'react';
import './About.css';

function About() {
  return (
    <main className="about-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="page-header-inner">
          <span className="section-label">Our Story</span>
          <h1>About Seminexis</h1>
          <p>Built to power India's semiconductor revolution.</p>
        </div>
      </section>

      {/* Company Overview */}
      <section className="about-overview">
        <div className="about-overview-inner">
          <div className="overview-text">
            <h2>Who We Are</h2>
            <p>
              Seminexis Pvt Ltd is a global distributor of high-quality silicon wafers, serving the
              semiconductor and advanced electronics industries. We specialize in sourcing and supplying
              precision-engineered wafers that meet the stringent standards required for cutting-edge
              manufacturing and research applications.
            </p>
            <p>
              We are more than a supplier. We are a collaborative partner for companies, research
              institutions, and innovators who are shaping India's technological future — whether
              supporting new semiconductor fabs, empowering R&D labs, or supplying specialty wafers
              for emerging applications.
            </p>
          </div>
          <div className="overview-stats">
            <div className="stat-card">
              <span className="stat-number">🇮🇳</span>
              <span className="stat-label">India-Focused</span>
            </div>
            <div className="stat-card">
              <span className="stat-number">🌍</span>
              <span className="stat-label">Global Sourcing</span>
            </div>
            <div className="stat-card">
              <span className="stat-number">⚡</span>
              <span className="stat-label">Precision Quality</span>
            </div>
          </div>
        </div>
      </section>

      {/* Founder Section */}
      <section className="founder-full">
        <div className="founder-full-inner">
          <div className="founder-left">
            <div className="founder-photo-large">
              <span>D</span>
            </div>
            <div className="founder-name-card">
              <h3>Darshan Pawar</h3>
              <p>Founder, Seminexis Pvt Ltd</p>
            </div>
          </div>

          <div className="founder-story">
            <span className="section-label">Meet Our Founder</span>
            <h2>A Vision for India's Semiconductor Future</h2>

            <p>
              I founded Seminexis Pvt Ltd with a clear vision to contribute meaningfully to India's
              semiconductor revolution. As the country invests in new fabs, advanced packaging
              facilities, and cutting-edge research, I felt a strong responsibility to be part of
              this historic transformation.
            </p>
            <p>
              My goal is to strengthen one of the most critical pillars of the ecosystem by ensuring
              reliable access to high-quality silicon wafers for companies across India.
            </p>
            <p>
              My experience working in the semiconductor environment has shown me how essential
              precision materials are to every stage of chip development. I have seen how the right
              wafer quality can improve yield, accelerate innovation, and enable breakthrough
              technologies. This understanding shapes the way Seminexis operates — combining
              technical expertise with global sourcing capabilities to deliver wafers that meet the
              highest standards of purity and performance.
            </p>
            <p>
              As the world moves deeper into an era defined by AI, electric mobility, 5G, aerospace,
              and digital transformation, semiconductor chips have become the foundation of progress.
              I founded Seminexis because I believe India deserves a strong and dependable supply
              chain that fuels this progress.
            </p>
            <blockquote>
              "Together, we can help build the future."
            </blockquote>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="mission-section">
        <div className="mission-inner">
          <h2>Our Mission</h2>
          <p>
            To connect global wafer manufacturers with India's growing demand for advanced
            semiconductor materials and to support every organization that is building the future —
            with precision, reliability, and partnership at the core of everything we do.
          </p>
        </div>
      </section>
    </main>
  );
}

export default About;
